import { OPEN_EVENT_SELECTOR_MODAL, CLOSE_EVENT_SELECTOR_MODAL } from './types';

export const openModal = () => ({ type: OPEN_EVENT_SELECTOR_MODAL });
export const closeModal = () => ({ type: CLOSE_EVENT_SELECTOR_MODAL });
